import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, first, tap, take } from 'rxjs/operators';
import { MemberEntityService } from '@views/pages/apps/general/members/services/member-entity.service';


@Injectable()
export class MemberResolver implements Resolve<boolean> {

    constructor(private memberService: MemberEntityService) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.memberService.loaded$.pipe(
          tap(loaded =>  {
            if(!loaded) {
              this.memberService.getAll().pipe(
                take(1)
              );
            }
          }),
          filter(loaded => !!loaded),
          first()
        );
    }

}
